import { useRef } from 'react';
import { FiUploadCloud, FiX } from 'react-icons/fi';

/**
 * Handles image selection with previews.
 * Value is a mixed array of strings (existing S3 urls) and File objects (new).
 * Parent submits Files via FormData and keeps existing urls in an `images` field.
 */
export default function ImageUploader({ value = [], onChange, multiple = true, label = 'Upload images' }) {
  const inputRef = useRef();

  const pick = (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    onChange(multiple ? [...value, ...files] : [files[0]]);
    e.target.value = '';
  };

  const remove = (idx) => onChange(value.filter((_, i) => i !== idx));

  const preview = (item) => (typeof item === 'string' ? item : URL.createObjectURL(item));

  return (
    <div>
      <div className="uploader" onClick={() => inputRef.current?.click()}>
        <FiUploadCloud size={26} style={{ marginBottom: 6 }} />
        <div>{label}</div>
        <small>PNG / JPG up to 8MB{multiple ? ' — multiple allowed' : ''}</small>
        <input ref={inputRef} type="file" accept="image/*" multiple={multiple} hidden onChange={pick} />
      </div>
      {value.length > 0 && (
        <div className="thumbs-row">
          {value.map((item, i) => (
            <div className="thumb-box" key={i}>
              <img src={preview(item)} alt={`upload ${i + 1}`} />
              <button type="button" onClick={() => remove(i)}><FiX /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// Split a mixed value array into existing url strings + new File objects.
export function splitImages(value = []) {
  const urls = value.filter((v) => typeof v === 'string');
  const files = value.filter((v) => typeof v !== 'string');
  return { urls, files };
}
